export default __webpack_public_path__ + "static/media/ChevronUp.8769b2d0.svg";